var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7.99961C1 7.22641 1.6268 6.59961 2.4 6.59961C3.1732 6.59961 3.8 7.22641 3.8 7.99961C3.8 8.77281 3.1732 9.39961 2.4 9.39961C1.6268 9.39961 1 8.77281 1 7.99961ZM6.6 7.99961C6.6 7.22641 7.2268 6.59961 8 6.59961C8.7732 6.59961 9.4 7.22641 9.4 7.99961C9.4 8.77281 8.7732 9.39961 8 9.39961C7.2268 9.39961 6.6 8.77281 6.6 7.99961ZM12.2 7.99961C12.2 7.22641 12.8268 6.59961 13.6 6.59961C14.3732 6.59961 15 7.22641 15 7.99961C15 8.77281 14.3732 9.39961 13.6 9.39961C12.8268 9.39961 12.2 8.77281 12.2 7.99961Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDots);
export default __webpack_public_path__ + "static/media/MenuDots.f35ab7f4ab0686df17f51799edd8fd0d.svg";
export { ForwardRef as ReactComponent };